import type { ReactNode } from 'react';

import deleteIcon from '@/assets/images/warning-icon.webp';

import { Modal } from '../modal';
import { OverlayPattern } from '../overlay';

import styles from './dialog.module.scss';

export type ConfirmDialogProps = {
  open: boolean;
  title: ReactNode;
  subtitle?: ReactNode;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
  loading?: boolean;
  icon?: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmDialog({
  open,
  title,
  subtitle,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  danger = false,
  loading = false,
  icon,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      size="sm"
      loading={loading}
      primaryText={confirmText}
      onPrimary={onConfirm}
      primaryDanger={danger}
      cancelText={cancelText}
      onCancel={onCancel}
      footerAlign="center"
    >
      <div className={styles.layout}>
        <OverlayPattern className={styles.pattern} />
        <span className={styles.iconWrap}>
          {icon ?? <img src={deleteIcon} alt="" aria-hidden="true" className={styles.icon} />}
        </span>
        <h2 className={styles.title}>{title}</h2>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
    </Modal>
  );
}
